import { LoadingState } from '@/config/loading-state';

// Helper to set global loading state
export const setLoading = (isLoading = false) => LoadingState.$emit('toggle', isLoading);

export function checkErrorRouterPush(context, error, code) {
    code = (typeof code !== 'undefined' ? code : 404);

    if (error.httpCode === code) {
        context.$router.push('/404');
    }
}
